import { useEffect, useState } from "react";
import { toast } from "sonner";
import { UserPlus, Trash2, FileText, Camera } from "lucide-react";
import { http, formatApiError } from "../lib/api";

const fr = (s) => (s ? new Date(s).toLocaleDateString("fr-FR") : "");

const open = async (id, which) => {
  const w = window.open("", "_blank");
  try {
    const r = await http.get(`/superadmin/candidates/${id}/file/${which}`, { responseType: "blob" });
    w.location.href = URL.createObjectURL(r.data);
  } catch (e) { w?.close(); toast.error(formatApiError(e)); }
};

export default function SuperCandidates() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  const [comp, setComp] = useState("");
  const load = () => http.get("/superadmin/candidates").then((r) => setRows(r.data)).catch((e) => toast.error(formatApiError(e)));
  useEffect(() => { load(); }, []);
  const del = (c) => window.confirm(`Supprimer définitivement la copie de la candidature de ${c.first_name} ${c.last_name} ?`) && http.delete(`/superadmin/candidates/${c.id}`).then(() => { toast.success("Copie supprimée"); load(); }, (e) => toast.error(formatApiError(e)));
  const companies = [...new Set(rows.map((r) => r.company_name))].sort();
  const shown = rows.filter((r) => (!comp || r.company_name === comp) && `${r.first_name} ${r.last_name} ${r.email} ${r.city}`.toLowerCase().includes(q.toLowerCase()));
  return (
    <div className="p-8 max-w-[1800px] mx-auto" data-testid="super-candidates-page">
      <h1 className="font-display text-4xl font-extrabold tracking-tight flex items-center gap-3"><UserPlus className="h-8 w-8" />Candidatures (toutes entreprises)</h1>
      <p className="text-sm text-slate-600 mt-1 mb-5">Copie XALTIX des candidatures reçues par les pages « Postuler » de chaque entreprise cliente. Non visible des entreprises.</p>
      <div className="flex flex-wrap gap-3 mb-4">
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Rechercher (nom, e-mail, ville)" className="border border-slate-300 rounded-md px-3 py-2 text-sm w-72" data-testid="sa-cand-search" />
        <select value={comp} onChange={(e) => setComp(e.target.value)} className="border border-slate-300 rounded-md px-3 py-2 text-sm" data-testid="sa-cand-company-filter">
          <option value="">Toutes les entreprises</option>{companies.map((c) => <option key={c}>{c}</option>)}
        </select>
        <span className="ml-auto text-sm text-slate-500 self-center" data-testid="sa-cand-count">{shown.length} candidature(s)</span>
      </div>
      <div className="bg-white border border-slate-200 rounded-md divide-y divide-slate-100">
        {shown.length === 0 && <p className="p-10 text-sm text-slate-500 text-center">Aucune candidature.</p>}
        {shown.map((c) => (
          <div key={c.id} className="flex flex-wrap items-center gap-3 px-4 py-3" data-testid={`sa-cand-row-${c.id}`}>
            <span className="font-semibold text-sm w-52 truncate">{c.civility} {c.first_name} {c.last_name}</span>
            <span className="text-xs text-slate-600 w-56 truncate">{c.email} · {c.phone}</span>
            <span className="text-xs text-slate-500 w-32 truncate">{c.postal_code} {c.city}</span>
            <span className="text-[11px] font-bold px-2 py-0.5 rounded-full bg-amber-50 text-[#8a6416] border border-amber-200" data-testid={`sa-cand-note-${c.id}`}>{c.note}</span>
            <span className="text-xs text-slate-500 ml-auto">{fr(c.copied_at)}</span>
            {c.files?.photo && <button type="button" onClick={() => open(c.id, "photo")} className="p-1.5 rounded hover:bg-slate-100" aria-label="Photo" data-testid={`sa-cand-photo-${c.id}`}><Camera className="h-4 w-4" /></button>}
            {c.files?.cv && <button type="button" onClick={() => open(c.id, "cv")} className="p-1.5 rounded hover:bg-slate-100" aria-label="CV" data-testid={`sa-cand-cv-${c.id}`}><FileText className="h-4 w-4" /></button>}
            <button type="button" onClick={() => del(c)} className="p-1.5 rounded hover:bg-rose-50 text-rose-600" aria-label="Supprimer" data-testid={`sa-cand-delete-${c.id}`}><Trash2 className="h-4 w-4" /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
